module.exports = __webpack_public_path__ + "static/media/menu.8b967fae.svg";